module.exports = __webpack_public_path__ + "img/1f9a8.116baac.svg";